// import {DogSvg, FacebookSvg, OdnoklassnikiSvg} from '@icons/social';
import { GoogleSvg, VkSvg } from '@icons/social';
import actualConfig from '../shared/config';

const { baseUrl } = actualConfig;
const generateUrl = (idp: string) => `${baseUrl}/api/a/oauth2/authorize/nkt?idp=${idp}&redirect_uri=${baseUrl}`;

export const socialNetworksSvg = [
  { icon: GoogleSvg, title: 'google', uri: generateUrl('google') },
  // { icon: FacebookSvg, title: 'fb', uri: `` },
  { icon: VkSvg, title: 'vk', uri: generateUrl('vk') },
  // { icon: OdnoklassnikiSvg, title: 'odnoklassniki', uri: `` },
  // { icon: DogSvg, title: '@', uri: `` },
];
